import { logi } from '@shared/utils/utils_logs';
import { create_performace_capture } from '@shared/utils/utils_performance';
import { load_foot_from_file } from './open_pose_load_foot';
import { load_hand_from_file } from './open_pose_load_hand';

export async function load_open_pose_fbx_models() {
  let performance_capture = create_performace_capture('load_open_pose_fbx_models');

  await Promise.all([load_hand_from_file(), load_foot_from_file()]);

  logi('🧍 fbx body parts loaded', { performance_capture });
}
